// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2B83f","col":"Table_col__-RQXj","fulfillmentStatus":"Table_fulfillmentStatus__15sEz","emailCol":"Table_emailCol__2zClI"};